var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicWandDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 11.6666L8.33321 9.16663M12.5085 2.91663V1.66663M15.7913 4.21718L16.6752 3.33329M15.7913 10.8333L16.6752 11.7172M9.17517 4.21718L8.29128 3.33329M17.0918 7.49996H18.3418M5.10935 17.3905L12.8071 9.69277C13.1371 9.36275 13.3021 9.19775 13.3639 9.00747C13.4183 8.8401 13.4183 8.65981 13.3639 8.49245C13.3021 8.30217 13.1371 8.13716 12.8071 7.80715L12.1927 7.19277C11.8627 6.86275 11.6977 6.69775 11.5074 6.63592C11.34 6.58154 11.1597 6.58154 10.9924 6.63592C10.8021 6.69775 10.6371 6.86275 10.3071 7.19277L2.60935 14.8905C2.27934 15.2205 2.11433 15.3855 2.0525 15.5758C1.99812 15.7431 1.99812 15.9234 2.0525 16.0908C2.11433 16.2811 2.27934 16.4461 2.60935 16.7761L3.22373 17.3905C3.55375 17.7205 3.71875 17.8855 3.90903 17.9473C4.0764 18.0017 4.25669 18.0017 4.42405 17.9473C4.61433 17.8855 4.77934 17.7205 5.10935 17.3905Z",
    stroke: "black",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicWandDark);
export default __webpack_public_path__ + "static/media/magic-wand-dark.e71fe0a7da06854f9ada404877d3d13c.svg";
export { ForwardRef as ReactComponent };